<div class="table-wrapper">
  <table
    class="alc-table headers-purpose"
    [class.no-results]="!dataSource.data || !dataSource.data.length"
    mat-table
    matSort
    [dataSource]="[]"
    [matSortDisableClear]="true"
    [matSortActive]="searchBarService.sort.active"
    [matSortDirection]="searchBarService.sort.direction"
    (matSortChange)="sortChange($event)">
    <ng-container [matColumnDef]="column.name" *ngFor="let column of columns">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        arrowPosition="before"
        matsort
        [disabled]="!column.sortEnabled">
        <span [translate]="column.translationKey"></span>
        <ng-container *ngIf="filters[column.name]">
          <app-header-table-filter
            *ngIf="filters[column.name].items?.length || filters[column.name].type === TableFilterTypeEnum.DATE"
            [items]="filters[column.name].items"
            [searchPlaceholderKey]="filters[column.name].placeholder"
            [filterName]="filters[column.name].name"
            [type]="filters[column.name].type"></app-header-table-filter>
        </ng-container>
      </th>
      <td mat-cell *matCellDef="let element"></td>
    </ng-container>

    <ng-container matColumnDef="actions" *ngIf="actions?.length">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr [class.hidden]="true" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr [class.hidden]="dataSource.data?.length" class="mat-row" *matNoDataRow>
      <span translate="no-results"></span>
    </tr>
  </table>

  <div class="dummy" #dummyAvailableHeight></div>
  <cdk-virtual-scroll-viewport
    *ngIf="dataSource.data?.length"
    tvsItemSize="60"
    [style.height.px]="maxHeight"
    class="wrapper"
    (scroll)="searchBarService.fetchItems({ scrollEvent: $event })">
    <table #table mat-table [dataSource]="dataSource" class="alc-table content-purpose">
      <ng-container [matColumnDef]="column.name" *ngFor="let column of columns">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <ng-container [ngSwitch]="column.type">
            <!-- date -->
            <span *ngSwitchCase="TableColumnTypeEnum.DATE">
              <div>{{ element[column.property] | dateTimezone: 'shortDate' }}</div>
              <small>{{ element[column.property] | dateTimezone: 'shortTime' }}</small>
            </span>

            <!-- site -->
            <ng-container *ngSwitchCase="TableColumnTypeEnum.SITE">
              <app-site-icon-and-name *ngIf="element.site" [item]="element.site">{{
                element.site.label
              }}</app-site-icon-and-name>
            </ng-container>

            <!-- label -->
            <mat-chip-list *ngSwitchCase="TableColumnTypeEnum.LABEL">
              <mat-chip [ngClass]="element[column.property].color">
                <span class="alc-ellipsis" [matTooltip]="element[column.property].text" appMatTooltipShowIfTruncated>{{
                  element[column.property].text
                }}</span>
                <span *ngIf="element.error && element.showError">
                  &nbsp;<mat-icon class="error-icon" (click)="element.showError(element.error)">help_outline</mat-icon>
                </span>
              </mat-chip>
            </mat-chip-list>

            <!-- activation status -->
            <span
              *ngSwitchCase="TableColumnTypeEnum.ACTIVE"
              class="activation"
              [class.inactive]="!element[column.property]">
              <ng-container *ngIf="element[column.property]; else inactive">
                <mat-icon>done</mat-icon>
                <span translate="active"></span>
              </ng-container>
              <ng-template #inactive>
                <mat-icon>block</mat-icon>
                <span translate="inactive"></span>
              </ng-template>
            </span>

            <!-- link -->
            <app-table-link *ngSwitchCase="TableColumnTypeEnum.LINK" [link]="element[column.property]"></app-table-link>

            <!-- template ref -->
            <ng-container
              *ngSwitchCase="TableColumnTypeEnum.TEMPLATE_REF"
              [ngTemplateOutlet]="element[column.property].templateRef"
              [ngTemplateOutletContext]="element[column.property].context">
            </ng-container>

            <!-- expandable list of strings -->
            <app-table-expandable-list
              *ngSwitchCase="TableColumnTypeEnum.LIST"
              [items]="element[column.property]"
              [column]="column"></app-table-expandable-list>

            <!-- expandable list of links (same as LIST, but can't group 2 ngSwitchCase -->
            <app-table-expandable-list
              *ngSwitchCase="TableColumnTypeEnum.LINK_LIST"
              [items]="element[column.property]"
              [column]="column"></app-table-expandable-list>

            <!-- strong -->
            <strong *ngSwitchCase="TableColumnTypeEnum.STRONG">{{ element[column.property] }}</strong>

            <!-- default -->
            <span *ngSwitchDefault>{{ element[column.property] }}</span>
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions" *ngIf="actions?.length">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <span class="float-action">
            <ng-container *ngFor="let action of actions">
              <span
                [ngClass]="action.customClass ? action.customClass(element) : ''"
                [matTooltip]="(data.disabled ? action.tooltipDisabled : action.tooltip) | translate"
                *ngIf="{
                  disabled: action.isDisabled && action.isDisabled(element)
                } as data">
                <mat-icon
                  [class.disabled]="data.disabled"
                  [color]="action.color || 'primary'"
                  (click)="action.clickFn(element)">
                  {{ action.icon }}
                </mat-icon>
              </span>
            </ng-container>
          </span>
        </td>
      </ng-container>

      <tr hidden mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        [class.hidden]="row.hide"
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="row.disable && config.disableLineClass"></tr>
    </table>
  </cdk-virtual-scroll-viewport>
</div>
